'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN
    const host = 'https://k.thewitn.com'
    if (token && !posthog.__loaded) {
      posthog.init(token, {
        api_host: host,
        ui_host: 'https://eu.posthog.com',
        defaults: '2026-05-30',
        person_profiles: 'identified_only',
        capture_pageview: 'history_change',
        capture_pageleave: true,
      })
    }
  }, [])

  return <PHProvider client={posthog}>{children}</PHProvider>
}
